import config from 'config';

function IMAGEM(props){
    let BASEIMAGEM, CLASS;
    if(!props.src || props.src === '' || props.src === 'null' || props.src === 'undefined'){
       return null;
    }
    if(!props.participantes){       
        BASEIMAGEM=`${config.BASEIMG}${props.src}`;
    } else {
        BASEIMAGEM=props.src; 
    }
    if(props.className){
        CLASS = `rounded mx-auto d-block ${props.className}`;
    }else{
        CLASS = `rounded mx-auto d-block`;
    }

    return <img src={BASEIMAGEM} className={CLASS} width={props.width} alt={props.alt || ""} />
}

export default IMAGEM;